import { defineNuxtPlugin } from '@nuxtjs/composition-api';
export default defineNuxtPlugin((nuxtApp) => {
  const config = nuxtApp.$config;
  const store = nuxtApp.app.store;

  const locale = nuxtApp.app.i18n?.locale || 'en';
  const siteHandle = store.localeSites?.[locale]?.siteHandle || 'default';

  const enabledSites = (config.enabledSearchSites || '').split(',');
  const enableSearch = enabledSites.includes(siteHandle);

  store.commit('global/setEnabledSearchLocales', enabledSites);
  store.commit('global/updateSearchFunctionality', enableSearch !== undefined ? enableSearch : true);
});
